var _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg333Fm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.65,349.13c28.964-79.663,57.749-158.833,86.686-238.421 c39.981,0.633,75.703,13.602,106.74,38.845c-28.854,79.365-57.585,158.397-86.531,238.013 C308.165,366.093,272.492,353.19,233.65,349.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.838,80.083c4.42-12.027,8.563-23.458,12.878-34.826 c0.492-1.296,1.739-2.749,2.988-3.244c13.553-5.377,27.471-9.129,42.2-9.437c20.949-0.437,35.875,10.381,48.05,25.878 c5.233,6.663,9.434,14.146,13.986,21.33c0.604,0.951,1.014,2.52,0.665,3.501c-4.166,11.724-8.492,23.391-12.912,35.446 C405.896,96.998,370.288,84.203,330.838,80.083z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.47,466.013c-0.836-1.796-1.426-3.058-2.015-4.322 c-10.146-21.757-20.293-43.514-30.436-65.271c-1.477-3.171,0.235-13.635,2.837-15.838c0.808-0.685,2.329-0.77,3.512-0.734 c37.824,1.162,71.613,13.455,101.417,36.785c2.047,1.602,2.333,2.969,1.693,5.562c-1.72,6.972-5.656,10.951-12.381,13.901 C294.57,445.542,273.393,455.79,251.47,466.013z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.597,
    y: 62.5,
    width: 100,
    height: 100
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.097,
    y: 202.5,
    width: 100,
    height: 100
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72.347,
    y: 342.5,
    width: 100,
    height: 100
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg333Fm);
export default __webpack_public_path__ + "static/media/333fm.1bb15bf2c18e81cb4fbf2022b6721a9c.svg";
export { ForwardRef as ReactComponent };